import { percentageFormat } from "@lib/text.helpers";
import { FEDERAL_TAX_BRACKETS } from "../budget.helpers";

import "./federal-tax-bracket.tooltip.scss";

export const FEDERAL_INCOME_TAX_TOOLTIP =
  "Federal income tax funds services like defense, education, infrastructure, and law enforcement.";

export const FederalTaxBracketTooltip = () => (
  <div className="federal-tax-bracket-tooltip">
    The US federal income tax system is progressive, meaning higher earners are
    taxed at higher rates.
    <ul>
      {FEDERAL_TAX_BRACKETS.map((bracket, i) => (
        <li key={`tax-bracket-${i}`}>
          {bracket.label} is {percentageFormat(bracket.percentage)}
        </li>
      ))}
    </ul>
  </div>
);
